import React from 'react';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';

interface Props {
    label: string;
    onClick: (e: React.MouseEvent) => void;
}

const IconButtonShowTicket = ({ label, onClick }: Props) => (
    <IconButton
        onClick={onClick}
        tooltipLabel={label}
        className="size-8 bg-gray-300"
        aria-label={label}
    >
        <Icon
            iconKey="articleOutlined"
            className="text-gray-600"
            size="1.25rem"
        />
    </IconButton>
);

export default IconButtonShowTicket;
